import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  contentChild,
  input,
  InputSignal,
  InputSignalWithTransform,
  Signal,
  ViewEncapsulation
} from '@angular/core';
import { NgControl, Validators } from '@angular/forms';

import { BooleanInputType } from '../core';

@Component({
  selector: 'tiime-input-container',
  templateUrl: './input-container.component.html',
  styleUrls: ['input-container.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  standalone: false,
  host: {
    class: 'tiime-input-container',
    /* eslint-disable @typescript-eslint/naming-convention */
    '[class.small]': 'small()',
    '[class.italic]': 'italic()'
    /* eslint-enable @typescript-eslint/naming-convention */
  }
})
export class InputContainerComponent {
  readonly contentId = input<string>(undefined!);
  readonly label: InputSignal<string | null> = input<string | null>(null);
  readonly errorMessage: InputSignal<string | null> = input<string | null>(null);
  readonly required: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly suffix: InputSignal<string | null> = input<string | null>(null);
  readonly small: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });
  readonly italic: InputSignalWithTransform<boolean, BooleanInputType> = input<boolean, BooleanInputType>(false, {
    transform: booleanAttribute
  });

  protected readonly control: Signal<NgControl | undefined> = contentChild(NgControl);

  protected readonly placeholder: Signal<string> = computed(() => {
    const label: string | null = this.label();
    const required: boolean = this.required();
    const control: NgControl | undefined = this.control();
    return `${label}${required || control?.control?.hasValidator(Validators.required) ? '*' : ''}`;
  });
}
